<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<Error403 v-if="coupon.status == 0" />

			<Maintenance v-else-if="coupon.status == 2" />

			<div v-else-if="coupon.status == 1">
				<LayoutTitle :coupon="coupon" />
				<LayoutPattern :coupon="coupon" />
				<LayoutModal :coupon="coupon" />
			</div>
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import LayoutTitle from "./components/LayoutTitle.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import LayoutModal from "./components/LayoutModal.vue";
import BaseLoading from "@/components/item/BaseLoading.vue";

import Error403 from "@/components/system/Page403.vue";
import Maintenance from "@/components/system/PageMaintenance.vue";

import Meta from "@/mixins/MetaSettable";

export default {
	mixins: [Meta],
	components: {
		LayoutTitle,
		LayoutPattern,
		LayoutModal,
		BaseLoading,

		Error403,
		Maintenance
	},
	data() {
		return {
			coupon: [],
			pageActive: false,
			loading: true
		};
	},

	created() {
		this.axios.get("/json/coupon.json").then(response => {
			this.coupon = response.data.coupon;
			this.loading = false;
			this.pageActive = true;
		});
	}
};
</script>

<style lang="scss">
</style>